import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const StatusPopup = () => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    title: "",
    message: "",
    type: "info",
    progress: 0,
    icon: "ℹ️",
    showCloseButton: true,
    btn: "",
    btnLink: "",
  });

  useEffect(() => {
    // ❌ Do not show on admission form page
    if (location.pathname === "/admission-form") {
      setShowPopup(false);
      return;
    }

    const checkStatus = () => {
      const status = sessionStorage.getItem("registerMember");

      if (!status) {
        setShowPopup(false);
        return;
      }

      if (status === "Status-1") {
        setPopupData({
          title: "🎉 Almost There!",
          message:
            "You have already registered successfully.\n\nPlease login to complete your Admission Form.",
          type: "success",
          progress: 30,
          icon: "📝",
          showCloseButton: true,
          btn: "🔐 Login Now",
        });
        setShowPopup(true);
      }

      if (status === "Status-2") {
        setPopupData({
          title: "🚀 One More Step!",
          message:
            "Your Admission Form is submitted successfully.\n\nPlease login to complete the payment.",
          type: "success",
          progress: 70,
          icon: "💳",
          showCloseButton: true,
          btn: "💳 Pay Now",
          btnLink: "https://razorpay.me/@sriramanujarenggcollege",
        });
        setShowPopup(true);
      }
    };

    // initial check
    // checkStatus();

    // ⏱ show again every 30 sec
    const interval = setInterval(checkStatus, 60000);

    return () => clearInterval(interval);
  }, [location.pathname]);

  const handleClose = () => {
    setShowPopup(false);
    // popup will auto-show again after 30 sec via interval
  };

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className={`popup-container ${popupData.type}`}>
        {/* Header */}
        <div className="popup-header">
          <div className="popup-icon">{popupData.icon}</div>

          {popupData.showCloseButton && (
            <button className="popup-close" onClick={handleClose}>
              ✕
            </button>
          )}
        </div>

        {/* Progress */}
        {popupData.progress > 0 && (
          <div className="popup-progress-container">
            <div className="popup-progress-bar">
              <div
                className="popup-progress-fill"
                style={{ width: `${popupData.progress}%` }}
              />
            </div>
            <div className="popup-progress-text">
              {popupData.progress}% Complete
            </div>
          </div>
        )}

        {/* Content */}
        <div className="popup-content">
          <h3 className="popup-title">{popupData.title}</h3>
          <p className="popup-message">
            {popupData.message.split("\n").map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </p>

          {/* Login text only */}
          {popupData.btnLink ? (
            <a
              href={popupData.btnLink}
              target="_blank"
              rel="noopener noreferrer"
              className="popup-action-btn"
            >
              {popupData.btn}
            </a>
          ) : (
            <p className="popup-login-text">{popupData.btn}</p>
          )}

          {/* <p className="popup-login-text">{popupData.btn}</p> */}
        </div>
      </div>
    </div>
  );
};

export default StatusPopup;
